@if ((basisartikelstand$ | async)) {
  <ng-container cdkTrapFocus>
    <form [formGroup]="form" class="pb-4">
      @for (hauptgruppe of $any(form).controls['hauptgruppen'].controls; track trackByIndex(hauptgruppeIndex, hauptgruppe); let hauptgruppeIndex = $index; let last = $last) {
        <div class="rounded w-full soft-card !p-0 mt-3"
          >
          <ng-container formArrayName="hauptgruppen">
            <ng-container [formGroupName]="hauptgruppeIndex">
              <div class="w-full py-[0.625rem] px-[0.825rem] gap-14 lg:gap-28 border-b border-primary-100">
                <div class="w-full font-semibold text-lg pb-1">
                  {{hauptgruppe?.controls['name']?.value || hauptgruppe?.controls['hauptgruppe']?.value || 'No Name'}}
                </div>
              </div>
            <div [ngClass]="hauptgruppeIndex === 0 ? 'grid lg:grid-cols-[auto_auto]'
                                                   : 'grid lg:grid-cols-[auto_auto] xl:grid-cols-[auto_auto_auto]'">
            <!--<div [ngClass]="hauptgruppeIndex === 0 ? 'grid lg:grid-cols-[400px_minmax(400px,_1fr)] xl:grid-cols-[600px_600px]'-->
            <!--                                       : 'grid lg:grid-cols-[380px_minmax(380px,_1fr)] xl:grid-cols-[380px_400px_400px]'">-->
                @for (untergruppe of $any(hauptgruppe).controls['untergruppen'].controls; track untergruppe; let untergruppeIndex = $index; let last = $last) {
                  <div
                    class="w-full p-4">
                    <ng-container formArrayName="untergruppen">
                      <ng-container [formGroupName]="untergruppeIndex">
                        <div [ngClass]="{'flex flex-col': hauptgruppeIndex !== 0}">
                          <table class="border border-primary-100 border-separate border-spacing-0">
                            <tr class="bg-primary-100 p-1">
                              <!-- Hauptgruppe 1 -->
                              @if (hauptgruppeIndex === 0) {
                                <th class="text-base text-left font-medium px-2 w-[45%]">
                                  {{ untergruppe?.controls['name']?.value || untergruppe?.controls['artikeluntergruppe']?.value || 'No Name' }}
                                </th>
                                <th class="text-base text-right font-medium w-[20%] px-2">{{ '#WWS_BASISARTIKELSTAND.UEBERSICHT.STUECK' | translate }}</th>
                                <th class="text-base text-right font-medium w-[10%] px-2">{{ '#WWS_BASISARTIKELSTAND.UEBERSICHT.AKTIONEN' | translate }}</th>
                              }
                              <!-- Hauptgruppe 2 -->
                              @if (hauptgruppeIndex !== 0) {
                                <th class="text-base font-medium w-[45%] text-left px-2">
                                  {{ untergruppe?.controls['name']?.value || untergruppe?.controls['artikeluntergruppe']?.value || 'No Name' }}
                                </th>
                                <th class="text-base text-right font-medium !w-[20%] px-2">
                                  {{ '#WWS_BASISARTIKELSTAND.UEBERSICHT.STUECK' | translate }}
                                </th>
                                <th class="text-base text-right font-medium !w-[20%] px-2">
                                  {{ '#WWS_BASISARTIKELSTAND.UEBERSICHT.ANZAHL' | translate }}
                                </th>
                                <th class="text-base text-left font-medium w-[10%] px-2">
                                  {{ '#WWS_BASISARTIKELSTAND.UEBERSICHT.EINHEIT' | translate }}
                                </th>
                              }
                            </tr>
                            @for (basisartikel of $any(untergruppe).controls['basisartikel'].controls; track basisartikel; let i = $index; let last = $last) {
                              <tr
                                class="w-full h-10">
                                <ng-container formArrayName="basisartikel">
                                  <ng-container [formGroupName]="i">
                                    <!-- Hauptgruppe 1 -->
                                    @if (hauptgruppeIndex === 0) {
                                      <ng-container formGroupName="artikel">
                                        <td class="border-r border-t border-solid border-gray-300 !p-0 !m-0 bg-gray-200">
                                          <soft-number-input
                                            textAlign="left"
                                            [readonly]="true"
                                            tabindex="-1"
                                      class="readonly [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none
                                            [&::-webkit-inner-spin-button]:appearance-none
                                            !border-none form-control px-2"
                                            formControlName="artkurzbez">
                                          </soft-number-input>
                                        </td>
                                      </ng-container>
                                      <ng-container formGroupName="beweinv">
                                        <td class="border-r border-t border-solid border-gray-300 px-2">
                                          <soft-number-input
                                            #numberInputComponent
                                            cdkMonitorSubtreeFocus
                                            (cdkFocusChange)="selectTextOnFocus($event, numberInputComponent.inputElement)"
                                            textAlign="right"
                                            formControlName="menge"
                                      class="[appearance:textfield]
                                             [&::-webkit-outer-spin-button]:appearance-none
                                             [&::-webkit-inner-spin-button]:appearance-none text-right border-none p-0 form-control">
                                          </soft-number-input>
                                        </td>
                                        <td class="px-2 border-t border-solid border-gray-300">
                                          <div (click)="openCommentDialog($safeNavigationMigration(basisartikel.controls['beweinv']?.controls['kommentar']?.value), $any(basisartikel))"
                                            class="w-min ml-auto">
                                            @if (basisartikel.controls['beweinv']?.controls['kommentar']?.value) {
                                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 text-primary cursor-pointer">
                                                <path fill-rule="evenodd" d="M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 01-3.476.383.39.39 0 00-.297.17l-2.755 4.133a.75.75 0 01-1.248 0l-2.755-4.133a.39.39 0 00-.297-.17 48.9 48.9 0 01-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97zM6.75 8.25a.75.75 0 01.75-.75h9a.75.75 0 010 1.5h-9a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H7.5z" clip-rule="evenodd" />
                                              </svg>
                                            }
                                            @if (!basisartikel.controls['beweinv']?.controls['kommentar']?.value) {
                                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-primary cursor-pointer">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                              </svg>
                                            }
                                          </div>
                                        </td>
                                      </ng-container>
                                    }
                                    <!-- Hauptgruppe 2 -->
                                    @if (hauptgruppeIndex !== 0) {
                                      <ng-container formGroupName="artikel">
                                        <td class="border-r border-t border-solid border-gray-300 !p-0 !m-0 bg-gray-200">
                                          <soft-number-input textAlign="left"
                                            [readonly]="true"
                                            tabindex="-1"
                                            class="!border-none form-control px-2"
                                            formControlName="artkurzbez">
                                          </soft-number-input>
                                        </td>
                                      </ng-container>
                                      <ng-container formGroupName="beweinv">
                                        <td class="border-r border-t border-solid border-gray-300 px-2">
                                          <soft-number-input
                                            #numberInputComponent
                                            cdkMonitorSubtreeFocus
                                            (cdkFocusChange)="selectTextOnFocus($event, numberInputComponent.inputElement)"
                                            formControlName="menge"
                                            textAlign="right"
                                      class="[appearance:textfield]
                                             [&::-webkit-outer-spin-button]:appearance-none
                                             [&::-webkit-inner-spin-button]:appearance-none text-right border-none p-0 form-control">
                                          </soft-number-input>
                                        </td>
                                        <td class="px-2 border-r border-t border-solid border-gray-300 text-right">
                                          <soft-number-input
                                            textAlign="right"
                                            formControlName="lagmenge"
                                            #numberInputComponent2
                                            cdkMonitorSubtreeFocus
                                            (cdkFocusChange)="selectTextOnFocus($event, numberInputComponent2.inputElement)"
                                       class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none
                                              [&::-webkit-inner-spin-button]:appearance-none text-right
                                              border-none p-0 form-control">
                                          </soft-number-input>
                                        </td>
                                        <td class="text-left p-2 border-t border-solid border-gray-300">
                                          {{ basisartikel?.controls['artikel']?.controls['arteh_lag']?.controls['arteh']?.value || 'No Data' }}
                                        </td>
                                      </ng-container>
                                    }
                                  </ng-container>
                                </ng-container>
                              </tr>
                            }
                            @for (summe of $any(untergruppe).controls['artikelsumme'].controls; track summe; let i = $index; let last = $last) {
                              <tr
                                class="bg-gray-200 font-bold h-10">
                                <ng-container formArrayName="artikelsumme">
                                  <ng-container [formGroupName]="i" class="block p-4">
                                    <td class="border-r border-t border-solid border-gray-300 !p-0 !m-0 bg-gray-200">
                                      <soft-number-input
                                        textAlign="left" [readonly]="true"
                                        tabindex="-1"
                                        class="!border-none form-control px-2"
                                        formControlName="name">
                                      </soft-number-input>
                                    </td>
                                    <td class="border-r border-t border-solid border-gray-300 px-2">
                                      <soft-number-input textAlign="right" [readonly]="true"
                                        tabindex="-1"
                                                   class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none
                                                          [&::-webkit-inner-spin-button]:appearance-none
                                                          border-none p-0 form-control"
                                        formControlName="summe">
                                      </soft-number-input>
                                    </td>
                                    <td class="px-2 text-right border-t border-solid border-gray-300" [ngClass]="{'border-r': hauptgruppeIndex !== 0}">
                                      @if (untergruppeIndex > 2 && untergruppeIndex < 5) {
                                        <soft-number-input
                                          textAlign="right" [readonly]="true"
                                          tabindex="-1"
                                                   class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none
                                                          [&::-webkit-inner-spin-button]:appearance-none
                                                          border-none p-0 form-control"
                                          formControlName="summe2">
                                        </soft-number-input>
                                      }
                                    </td>
                                    @if (hauptgruppeIndex !== 0) {
                                      <td class="px-2 text-left border-t border-solid border-gray-300">
                                        @if (untergruppeIndex > 2 && untergruppeIndex < 5) {
                                          <div>
                                            {{ '#WWS_BASISARTIKELSTAND.UEBERSICHT.KG' | translate }}
                                          </div>
                                        }
                                      </td>
                                    }
                                  </ng-container>
                                </ng-container>
                              </tr>
                            }
                          </table>
                          @if ($any(untergruppe).controls['weitereArtikel']?.value.length > 0) {
                            <button
                              type="button"
                              tabindex="-1"
                              class="flex ml-auto mt-2 px-2 py-1 border border-solid rounded border-primary text-primary"
                              (click)="openArtikelHinzufuegenDialog($any(untergruppe))">
                              {{ '#WWS_BASISARTIKELSTAND.UEBERSICHT.BUTTON_HINZUFUEGEN' | translate }}
                            </button>
                          }
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                }
              </div>
            </ng-container>
          </ng-container>
        </div>
      }
    </form>
  </ng-container>
} @else {
  <div class="rounded w-full soft-card mt-3" *softRepeat="2">
    <div class="rounded w-20 h-8 skeleton ml-5"></div>
    <br>
      <div class="rounded w-1/3 h-32 skeleton mt-2 ml-5" *softRepeat="2"></div>
    </div>
  }

